module.exports = __webpack_public_path__ + "media/images/dashboards/pharmacy-a44231f3cf91697f9c2aece9bdc63bd9.png";